export const LOGIN = 'LOGIN'
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
export const LOGIN_ERROR = 'LOGIN_ERROR'
export const SIGNUP = 'SIGNUP'
export const FORGOT_PASSWORD = 'FORGOT_PASSWORD'



// WEBPACK FOOTER //
// ./src/actions/types.js